package com.flowyride.core.api

import com.flowyride.core.domain.loop.CompassDirection
import com.flowyride.core.domain.loop.GeneratedLoop
import com.flowyride.core.domain.loop.LoopRequest
import com.flowyride.core.domain.loop.LoopTarget
import com.flowyride.core.domain.model.RouteEngineId

fun LoopRequest.toDto() = LoopRequestDto(
    start = start.toDto(),
    distanceMeters = (target as? LoopTarget.Distance)?.meters,
    durationSeconds = (target as? LoopTarget.Duration)?.seconds,
    direction = direction?.let { CompassDirectionDto.valueOf(it.name) },
    preferences = preferences.toDto(),
    seed = seed,
)

/** @throws IllegalArgumentException on invalid coordinates, a missing or double target, or one out of range. */
fun LoopRequestDto.toDomain(): LoopRequest {
    require((distanceMeters == null) != (durationSeconds == null)) { "Set either a distance or a duration" }
    return LoopRequest(
        start = start.toDomain(),
        target = distanceMeters?.let { LoopTarget.Distance(it) } ?: LoopTarget.Duration(durationSeconds!!),
        direction = direction?.let { CompassDirection.valueOf(it.name) },
        preferences = preferences.toDomain(),
        seed = seed,
    )
}

fun GeneratedLoop.toDto() = LoopResponseDto(
    waypoints = waypoints.map { it.toDto() },
    route = route.toDto(),
)

/** As for routes, the server's engine is an implementation detail. */
fun LoopResponseDto.toDomain(engineId: RouteEngineId) = GeneratedLoop(
    waypoints = waypoints.map { it.toDomain() },
    route = route.toDomain(engineId),
)
